// @flow

import numeral from "numeral"

const getAsNumber = (value: string): number =>
  numeral(value.replace(/[^\d]/g, "")).value()

export const numberField = (value: string) => {
  const onlyNums = value.replace(/[^\d]/g, "")
  return getAsNumber(onlyNums)
}

export const numberFieldAsString = (value: string) => {
  const onlyNums = value.replace(/[^\d]/g, "")
  return onlyNums
}

export const normalizePercentage = (value: string, previousValue: string) => {
  const onlyNums = numeral(value.replace(/[^\d,.]/g, "")).value()
  if (onlyNums > 100) {
    return previousValue
  }
  return onlyNums
}

export const normalizeYears = (value: string, previousValue: string) => {
  const onlyNums = value.replace(/[^\d]/g, "")
  if (onlyNums.length > 4) {
    return previousValue
  }
  return onlyNums
}

export const normalizeMonths = (value: string, previousValue: string) => {
  const onlyNums = getAsNumber(value)
  if (onlyNums > 12) {
    return previousValue
  }
  return onlyNums
}

export const normalizeDays = (value: string, previousValue: string) => {
  const onlyNums = getAsNumber(value)
  if (onlyNums > 31) {
    return previousValue
  }
  return onlyNums
}

export const normalizePhone = (value: string, previousValue: string) => {
  if (!value) {
    return value
  }
  const onlyNums = value.replace(/[^\d]/g, "")
  if (!previousValue || value.length > previousValue.length) {
    // typing forward
    if (onlyNums.length === 3) {
      return onlyNums + "-"
    }
    if (onlyNums.length === 6) {
      return onlyNums.slice(0, 3) + "-" + onlyNums.slice(3) + "-"
    }
  }
  if (onlyNums.length <= 3) {
    return onlyNums
  }
  if (onlyNums.length <= 6) {
    return onlyNums.slice(0, 3) + "-" + onlyNums.slice(3)
  }
  return (
    onlyNums.slice(0, 3) +
    "-" +
    onlyNums.slice(3, 6) +
    "-" +
    onlyNums.slice(6, 10)
  )
}

export const normalizeMLS = (value: string, previousValue: string) => {
  if (!value) {
    return value
  }
  const onlyNums = value.replace(/[^\d]/g, "")
  if (onlyNums.length > 8) {
    return previousValue
  }
  return onlyNums
}

export const upper = (value: string) => value && value.toUpperCase()
export const lower = (value: string) => value && value.toLowerCase()

export const lessThanOtherField = (otherField: string) => (
  value: number,
  previousValue: number,
  allValues: any
) => (value < allValues[otherField] ? value : previousValue)

export const greaterThanOtherField = (otherField: string) => (
  value: number,
  previousValue: number,
  allValues: any
) => (value > allValues[otherField] ? value : previousValue)

export const normalizeToNumber = (value: string): number =>
  Math.abs(numeral(value).value())

export const normalizeMoney = (value: number = 0): string =>
  value ? numeral(value).format("$ 0,0[.]00") : "$ 0"

export const normalizeWithMax = (max: number | string) => (value: string) => {
  const valueAsNumber = normalizeToNumber(value)
  const maxValue = typeof max === "string" ? normalizeToNumber(value) : max
  return valueAsNumber >= maxValue ? maxValue : valueAsNumber
}

export const normalizeWithMin = (min: number) => (value: number) =>
  value >= min ? value : min

export const chain = (normalizeFuncts: Function[]) => (value: any) =>
  normalizeFuncts.reduce((acc, fn) => fn(acc), value)

export const normalizeToBool = (value: string) => value === "true"

export const normalizeToStringFromBool = (value: boolean) => {
  if (typeof value === "boolean") return value ? "true" : "false"
  return value
}

export const normalizeToPastYear = (value: string, previousValue: string) => {
  const currentDate = new Date()
  const onlyNums = value.replace(/[^\d,.]/g, "")
  if (onlyNums.length > 4) {
    return previousValue
  }
  if (getAsNumber(onlyNums) > currentDate.getFullYear()) {
    return previousValue
  }
  return onlyNums
}

export const serverFriendlyDateFormat = (value: string) => {
  const simpleDate = value.split("T")[0]
  return `${simpleDate}T00:00:00Z`
}



// WEBPACK FOOTER //
// ./src/lib/normalizers.js